import { useContext, useEffect, useState } from 'react'

import { Box, Pagination, Spinner, Text } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { OriginInvoiceContext } from '../../origin-invoice.context'
import { OrderItem } from '../OrderItem/order-item.comp'

export const OrdersTab = () => {
  const [page, setPage] = useState(1)
  const theme = useTheme()

  const { invoice, orders, loadingItems, actions } =
    useContext(OriginInvoiceContext)

  useEffect(() => {
    actions.getOrders(invoice?.id ?? '', page)
  }, [page])

  const Error = () => {
    return (
      <Box
        flex={1}
        direction="column"
        alignItems="center"
        padding={8}
        width="100%"
        backgroundColor="white"
        borderRadius={theme.border_radius.box}
        border={{
          color: 'grey_5',
          width: 1,
        }}
        boxShadow={theme.box_shadow.card}
      >
        <Text align="center">Não há dados</Text>
      </Box>
    )
  }
  if (!invoice || !orders) return <Error />

  if (loadingItems) {
    return (
      <Box width="100%" padding={3} justifyContent="center">
        <Spinner size="40px" />
      </Box>
    )
  }

  return (
    <Box width="100%" direction="column" gap={3}>
      <Text>{`${orders.count} Ordem(s) de compra produzidas com a NF ${invoice.code}`}</Text>
      <Box width="100%" direction="column" alignItems="center" gap={2}>
        {orders.data.map((order, index) => (
          <OrderItem order={order} key={`order-item-${index}`} />
        ))}
        <Pagination
          total={Math.ceil(orders?.count / 10) ?? 1}
          current={page}
          onChange={(_page) => setPage(_page)}
        />
      </Box>
    </Box>
  )
}
